import { render, staticRenderFns } from "./RussianPost.vue?vue&type=template&id=56b7f468&"
import script from "./RussianPost.vue?vue&type=script&lang=js&"
export * from "./RussianPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports